import { createSlice } from '@reduxjs/toolkit';

const toastSlice = createSlice({
  name: 'toasts',
  initialState: [],
  reducers: {
    addToast: (state, action) => {
      const newToast = {
        id: Date.now().toString(),
        ...action.payload,
      };
      state.push(newToast);
    },
    removeToast: (state, action) => {
      return state.filter(toast => toast.id !== action.payload);
    },
  },
});

export const { addToast, removeToast } = toastSlice.actions;
export default toastSlice.reducer;